module.exports = __webpack_public_path__ + "img/poro-question.25a63792.png";